"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const alert_1 = require("@kawaui/alert");
const react_1 = require("react");
const constants_1 = require("./constants");
const styles_1 = require("./styles");
const defaultOnRouting = (url) => {
    window.location.href = url;
};
const defaultI18n = (key) => key;
const FrozenCartDialog = ({ open, onClose, paymentUrl, defrost, onRouting = defaultOnRouting, track = () => null, i18n = defaultI18n, }) => {
    (0, react_1.useEffect)(() => {
        if (open)
            track(...constants_1.frozenRender);
    }, [open]);
    const onDefrost = () => {
        track(...constants_1.defrostClick);
        return defrost();
    };
    const onPay = () => {
        track(...constants_1.payClick);
        return onRouting(paymentUrl);
    };
    return ((0, jsx_runtime_1.jsxs)(alert_1.Alert, { open: open, onClose: onClose, children: [(0, jsx_runtime_1.jsx)(styles_1.Title, { children: i18n('frozen_cart.modal.title') }), (0, jsx_runtime_1.jsx)(alert_1.Content, { children: i18n('frozen_cart.modal.text') }), (0, jsx_runtime_1.jsxs)(alert_1.Footer, { children: [(0, jsx_runtime_1.jsx)(alert_1.AlertButton, { isAsync: true, variant: "tertiary", onClick: onDefrost, children: i18n('frozen_cart.modal.cta.2') }), paymentUrl && ((0, jsx_runtime_1.jsx)(alert_1.AlertButton, { isAsync: true, onClick: onPay, children: i18n('frozen_cart.modal.cta.1') }))] })] }));
};
exports.default = FrozenCartDialog;
